export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const UPPERCASE_REGEX = /[A-Z]/;
export const SPECIAL_CHAR_REGEX = /[^a-zA-Z0-9]/;
export const NUMBERS_ONLY_REGEX = /^\d+$/;
export const WEBSITE_REGEX = /^(https?:\/\/)?([\w\d-]+\.)+[\w-]{2,}(\/.*)?$/i;
export const SOCIAL_MEDIA_REGEX = /(facebook|instagram|twitter|x\.com|linkedin|tiktok|youtube|pinterest)\.com/i;
